export const network = {
    title: 'Network',
    tooltip:
        'You can view the inventor network within a specified company or a specific company (competitor or alliance candidate). It is possible to identify inventors with a high development center, and to find candidates for expert interviews and recruitment personnel. It is also possible to identify the development center person of the alliance destination and consider the representation and warranty of the intellectual property DD. In addition, since the inventor population, score, and number of patent applications are displayed in chronological order for each development theme (technology cluster) that a specific company is focusing on, the R & D roadmap for a specific company can be estimated from these. Can be grasped.',
    clustersCount: 'Number of Clusters',
    researcher: 'Inventor',
    centrality: 'Centrality',
    companyName: 'Company',
    cluster: 'Cluster',
    chart1Title: "Company's Inventor Network",
    chart2Title: "Competitor's Inventor Network",
    chart3Title: "Cluster's Inventor Network",
    chart4Title: 'R&D Roadmap',
    chart4ButtonSelectAll: 'Select All',
    chart4ButtonUnSelectAll: 'UnSelect All',

    year: 'Year',
    numberofinventors: 'Number of Inventors',
    process: 'Process',
    ipcName: 'Technology Classification'
}
